import { createSlice, isAnyOf, PayloadAction } from "@reduxjs/toolkit";
import { StepDefinition } from "onfido-sdk-ui/types/shared/Types";
import { getNextOnfidoPhase, setupOnfidoConfigurations } from "../actions";
import {
  allOnfidoFulfilledMatchers,
  allOnfidoPendingMatchers,
  allOnfidoRejectedMatchers,
} from "../api";
import { TEventName } from "../types";

export type OnfidoPhases = {
  steps: StepDefinition[];
  token: string;
}[];

export interface OnfidoState {
  isLoading: boolean;
  hasError: boolean;
  phases: OnfidoPhases;
  currentPhaseIndex: number;
  subStep?: TEventName | null;
  isCrossDevice: boolean;
}

export const onfidoInitialState: OnfidoState = {
  isLoading: false,
  hasError: false,
  phases: [],
  currentPhaseIndex: 0,
  subStep: null,
  isCrossDevice: false,
};

type ActionType = PayloadAction<Partial<OnfidoState>>;

export const onfidoSlice = createSlice({
  name: "onfidoSlice",
  initialState: onfidoInitialState,
  reducers: {
    setOnfidoState: (state: OnfidoState, action: ActionType) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getNextOnfidoPhase?.pending, state => {
        state.isLoading = true;
      })
      .addCase(getNextOnfidoPhase?.fulfilled, state => {
        state.isLoading = false;
      })
      .addCase(getNextOnfidoPhase?.rejected, () => ({
        ...onfidoInitialState,
        hasError: true,
      }))
      .addCase(setupOnfidoConfigurations.pending, state => {
        state.isLoading = true;
      })
      .addCase(setupOnfidoConfigurations.fulfilled, state => {
        state.isLoading = false;
      })
      .addCase(setupOnfidoConfigurations.rejected, () => ({
        ...onfidoInitialState,
        hasError: true,
      }))
      .addMatcher(isAnyOf(...allOnfidoRejectedMatchers), () => {
        return {
          ...onfidoInitialState,
          isLoading: false,
          hasError: true,
        };
      })
      .addMatcher(isAnyOf(...allOnfidoFulfilledMatchers), state => {
        return {
          ...state,
          isLoading: false,
        };
      })
      .addMatcher(isAnyOf(...allOnfidoPendingMatchers), state => {
        return {
          ...state,
          isLoading: true,
        };
      });
  },
});

export const { setOnfidoState } = onfidoSlice.actions;
